/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { Menu } from "primereact/menu";
import { Tag } from "primereact/tag";
import { Boton, Titulo, Formulario, accessAPI, Sidebar, TablaFiltrable } from "../../../shared";

export default function SitioTipos() {
  const [loader, setLoader] = useState(true);
  const [tipos, setTipos] = useState([]);

  const [sideBarNuevo, setSideBarNuevo] = useState(false);
  const [loaderNuevo, setLoaderNuevo] = useState(false);
  const [formNuevoKey, setFormNuevoKey] = useState(0);

  const [sideBarEditar, setSideBarEditar] = useState(false);
  const [loaderEditar, setLoaderEditar] = useState(false);
  const [formEditarKey, setFormEditarKey] = useState(0);

  const [sideBarMigrar, setSideBarMigrar] = useState(false);
  const [loaderMigrar, setLoaderMigrar] = useState(false);
  const [formMigrarKey, setFormMigrarKey] = useState(0);

  const [selectedTipo, setSelectedTipo] = useState(null);

  const toast = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    cargarTipos();
  }, []);

  function cargarTipos() {
    accessAPI(
      "GET",
      "admin/sitio/tipos",
      null,
      (respuesta) => {
        setTipos(respuesta);
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar tipos de sitio",
          sticky: true
        });
        setLoader(false);
      }
    );
  }

  function crearTipo(campos) {
    setLoaderNuevo(true);
    accessAPI(
      "POST",
      "admin/sitio/tipos",
      campos,
      (respuesta) => {
        setTipos((prev) => [...prev, respuesta]);
        setSideBarNuevo(false);
        setLoaderNuevo(false);
      },
      (respuesta) => {
        setLoaderNuevo(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al crear tipo de sitio",
          sticky: true
        });
      }
    );
  }

  function editarTipo(campos) {
    setLoaderEditar(true);
    accessAPI(
      "PUT",
      `admin/sitio/tipos/${selectedTipo.id}`,
      campos,
      (respuesta) => {
        setTipos((prev) =>
          prev.map((t) => (t.id === selectedTipo.id ? respuesta : t))
        );
        setSideBarEditar(false);
        setLoaderEditar(false);
      },
      (respuesta) => {
        setLoaderEditar(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al editar tipo de sitio",
          sticky: true
        });
      }
    );
  }

  function eliminarTipoConMigracion(campos) {
    setLoaderMigrar(true);
    accessAPI(
      "DELETE",
      `admin/sitio/tipos/${selectedTipo.id}`,
      { nuevoTipoId: campos.nuevoTipoId },
      () => {
        const migradoId = parseInt(campos.nuevoTipoId);
        const sitiosMigrados = selectedTipo._count.sitios;
        setTipos((prev) =>
          prev
            .filter((t) => t.id !== selectedTipo.id)
            .map((t) =>
              t.id === migradoId
                ? {
                    ...t,
                    _count: {
                      ...t._count,
                      sitios: (t._count?.sitios || 0) + sitiosMigrados
                    }
                  }
                : t
            )
        );
        setSideBarMigrar(false);
        setLoaderMigrar(false);
        toast.current?.show({
          severity: "success",
          summary: "Tipo de sitio eliminado",
          detail: `${sitiosMigrados} sitios migrados`,
          life: 3000
        });
      },
      (respuesta) => {
        setLoaderMigrar(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al eliminar tipo de sitio",
          sticky: true
        });
      }
    );
  }

  const menuItems = selectedTipo
    ? [
        {
          label: "Editar",
          icon: "pi pi-pencil",
          command: () => {
            setFormEditarKey((k) => k + 1);
            setSideBarEditar(true);
          }
        },
        {
          label: "Eliminar",
          icon: "pi pi-trash",
          command: () => {
            setFormMigrarKey((k) => k + 1);
            setSideBarMigrar(true);
          }
        }
      ]
    : [];

  const nuevoFormConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "nombre",
            tipoitemformularioid: 1,
            etiqueta: "Nombre",
            requerido: true
          },
          {
            nombre: "esFabrica",
            tipoitemformularioid: 6,
            etiqueta: "Es fábrica"
          },
          {
            nombre: "esFabricante",
            tipoitemformularioid: 6,
            etiqueta: "Es fabricante"
          },
          {
            nombre: "camposAdicionales",
            tipoitemformularioid: 13,
            etiqueta: "Campos adicionales"
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Crear tipo de sitio",
        callback: crearTipo,
        validar: true
      }
    ]
  };

  const editarFormConfig = selectedTipo
    ? {
        secciones: [
          {
            campos: [
              {
                nombre: "nombre",
                tipoitemformularioid: 1,
                etiqueta: "Nombre",
                requerido: true,
                respuesta: selectedTipo.nombre
              },
              {
                nombre: "esFabrica",
                tipoitemformularioid: 6,
                etiqueta: "Es fábrica",
                respuesta: selectedTipo.esFabrica
              },
              {
                nombre: "esFabricante",
                tipoitemformularioid: 6,
                etiqueta: "Es fabricante",
                respuesta: selectedTipo.esFabricante
              },
              {
                nombre: "camposAdicionales",
                tipoitemformularioid: 13,
                etiqueta: "Campos adicionales",
                respuesta: selectedTipo.camposAdicionales || []
              }
            ]
          }
        ],
        botones: [
          {
            etiqueta: "Guardar cambios",
            callback: editarTipo,
            validar: true
          }
        ]
      }
    : null;

  const migrarFormConfig = selectedTipo
    ? {
        secciones: [
          {
            campos: [
              {
                nombre: "nuevoTipoId",
                tipoitemformularioid: 5,
                etiqueta: "Migrar los sitios existentes al tipo",
                requerido: true,
                sinOpcionInicial: true,
                opciones: tipos
                  .filter((t) => t.id !== selectedTipo.id)
                  .map((t) => ({ value: t.id, etiqueta: t.nombre }))
              }
            ]
          }
        ],
        botones: [
          {
            etiqueta: "Migrar y eliminar",
            callback: eliminarTipoConMigracion,
            validar: true
          }
        ]
      }
    : null;

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <Menu model={menuItems} popup ref={menuRef} />

      <Sidebar
        visible={sideBarNuevo}
        onHide={() => setSideBarNuevo(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Nuevo tipo de sitio</Titulo>
        <Formulario
          key={formNuevoKey}
          config={nuevoFormConfig}
          loader={loaderNuevo}
        />
      </Sidebar>

      <Sidebar
        visible={sideBarEditar}
        onHide={() => setSideBarEditar(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Editar tipo de sitio</Titulo>
        {editarFormConfig && (
          <Formulario
            key={formEditarKey}
            config={editarFormConfig}
            loader={loaderEditar}
          />
        )}
      </Sidebar>

      <Sidebar
        visible={sideBarMigrar}
        onHide={() => setSideBarMigrar(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        {selectedTipo && (
          <>
            <Titulo>Eliminar "{selectedTipo.nombre}"</Titulo>
            <p css={{ color: "var(--grisTextos)" }}>
              Hay{" "}
              <strong>{selectedTipo._count?.sitios}</strong> sitio
              {selectedTipo._count?.sitios === 1 ? "" : "s"} asociado
              {selectedTipo._count?.sitios === 1 ? "" : "s"} a este tipo.
              Elija a qué tipo migrarlos antes de eliminar.
            </p>
            {migrarFormConfig && (
              <Formulario
                key={formMigrarKey}
                config={migrarFormConfig}
                loader={loaderMigrar}
              />
            )}
          </>
        )}
      </Sidebar>

      <Titulo urlVolver="/config">Tipos de sitio</Titulo>

      {loader && (
        <Card>
          <Skeleton width="100%" height="3rem" />
          {[...Array(3)].map((_, i) => (
            <Skeleton
              key={i}
              width="100%"
              height="3.5rem"
              css={{ marginTop: "0.3rem" }}
            />
          ))}
        </Card>
      )}

      {!loader && (
        <Card>
          <Titulo
            botones={
              <Boton
                texto
                negro
                callback={() => {
                  setFormNuevoKey((k) => k + 1);
                  setSideBarNuevo(true);
                }}
              >
                <i className="pi pi-plus" />
              </Boton>
            }
          >
            Tipos
          </Titulo>
          <TablaFiltrable conFiltros={false}
            value={tipos}
            stripedRows
            emptyMessage="No hay tipos de sitio configurados"
            nombreArchivo="tipos_sitio"
          >
            <Column header="Nombre" field="nombre" />
            <Column
              header="Flags"
              body={(rowData) => (
                <div css={{ display: "flex", gap: "0.5em", flexWrap: "wrap" }}>
                  {rowData.esFabrica && (
                    <Tag value="Fábrica" severity="info" />
                  )}
                  {rowData.esFabricante && (
                    <Tag value="Fabricante" severity="info" />
                  )}
                  {rowData.esSedePrincipal && (
                    <Tag value="Sede principal" severity="success" />
                  )}
                </div>
              )}
            />
            <Column
              body={(rowData) => (
                <Boton
                  texto
                  negro
                  chico
                  callback={(e) => {
                    setSelectedTipo(rowData);
                    menuRef.current.toggle(e);
                  }}
                >
                  <i className="pi pi-ellipsis-v" />
                </Boton>
              )}
              style={{ width: "60px", textAlign: "center" }}
            />
          </TablaFiltrable>
        </Card>
      )}
    </>
  );
}
